import _ from "lodash";
import { Observable, of, throwError } from "rxjs";

import { SpecimenResource, EntityType, MaskFieldCompleteResource, SynchroMediaUpdates } from "@skinsoft/types";
import { SpecimenRecordMask } from "@skinsoft/record-mask-configs";
import { SpecimenDataStore } from "@skinsoft/entity";
import { EntitySyncUpHandler } from "../../entity-sync-up-handler/entity-sync-up-handler";
import { SpecimenOfflineDataUpdateCacher } from "@skinsoft/offline";
import { getOnlyValuesFromMaskFields } from "@skinsoft/utils";


// @ts-ignore
export class SpecimenSyncUpHandler extends EntitySyncUpHandler<SpecimenResource, SpecimenResource> {
    
    public static getInstance() {
        if (!SpecimenSyncUpHandler.instance) {
            SpecimenSyncUpHandler.instance = new SpecimenSyncUpHandler()
        }

        return SpecimenSyncUpHandler.instance
    }

    public static install(Vue) {
        SpecimenSyncUpHandler.getInstance()
    }

    private static instance: SpecimenSyncUpHandler = null as any

    private constructor() {
        super(
            new SpecimenOfflineDataUpdateCacher(),
            SpecimenDataStore.getInstance(),
            EntityType.SPECIMEN
        )
    }

    getAndFormatModificationsBeforeMerge(localEntity: SpecimenResource): Observable<Partial<SpecimenResource>> {
        const res: Partial<SpecimenResource> = {}

        if(localEntity) {
            const masks: MaskFieldCompleteResource[] = SpecimenRecordMask.categories?.flatMap(category => category.maskFields ?? []) ?? []

            const values = getOnlyValuesFromMaskFields(
                localEntity,
                masks,
            )

            for(const [key, value] of Object.entries(values)) {
                _.set(
                    res,
                    key,
                    value
                )
            }


            // the associated medias are not in the mask, so we need to copy them (as it will not be done 
            // automatically)
            const associatedMedias = _.get(localEntity, "associatedMedias")
            if(associatedMedias) {
                _.set(
                    res,
                    "associatedMedias",
                    associatedMedias
                )
            }
        }

        return of(res)
    }

    createNewEntity(dataToCreate: SynchroMediaUpdates<SpecimenResource>): Observable<SpecimenResource> {
        return (this.dataStore as SpecimenDataStore).create(dataToCreate.body)
    }

    getType(): EntityType {
        return EntityType.SPECIMEN
    }
}